//creazione del button che permette l'apertura del drawer per l'aggiunta layer
import React from 'react'
import {Component} from 'react'
import addLayerImage from './AddlayerBlack.svg'
import Tooltip from '@material-ui/core/Tooltip';

export default class ButtonAddLayer extends Component {
    
constructor(props){
    super(props);
    this.state = {
        buttonStyle: props.button,

        isToggleOn: true
      }

          
          this.handleClick = this.handleClick.bind(this);

}

handleClick() {
    this.setState(function(prevState) {
        this.props.openMenu(true)
        return {isToggleOn: !prevState.isToggleOn};
    });
    
}

render() {   
    return (
        // <Slide direction="left" in={this.state.isToggleOn } >
        <Tooltip title="Aggiungi layer">
        <button  style={ this.state.buttonStyle} onClick={this.handleClick}>
            <img style={{width: '22px',height: '22px'}} src={addLayerImage}  alt="trip"/>
        </button>
        </Tooltip>
        )
    }
}